
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  if(window.flitsObjects.allCssJs.cartJs){
    if(Flits.Metafields.IS_STORE_CREDIT_PAID && Flits.Metafields.is_store_credit_enable && window.flitsObjects.storeData.customer_id != -1){
      Flits.LoadStyleScript('cartJs',window.flitsObjects.allCssJs.cartJs.url);
    }
  }
   Flits(document).on('Flits:SocialLogin:Loaded', function(event){  
    setTimeout(function(){
      if (location.pathname.indexOf("/account") == -1){  
        Flits.setLocalStorage('flits_before_login_url','/account');
      }
    }, 800);
  });

  Flits(window).load(function() {  
    if (location.pathname.indexOf("/account") == -1){     
      if (location.pathname.indexOf("checkout") != -1)
      {
        Flits.setLocalStorage('flits_before_login_url',location.pathname);
      }else{
        Flits.setLocalStorage('flits_before_login_url','/account');
      }
    }
  });
  Flits(document).on('change', '.cart-main-part-form .flits-credit-code-div .flits-cart-drp.flits-select-row select.flits-input', function(){
    Flits(this).parents('.cart__footer').find('#cart-errors').hide();
  });
  Flits(document).on('Flits:CartAutomaticCode:Loaded', function(event){

    var data = event.detail;
    
    var el = data.el;
    var parent = Flits(data.parent).parent(); // parent
    var cloneNode = data.cloneNode; // cloned social login div
    if(Flits(parent).parents('.cart-side-panel').length){
      parent.prepend(cloneNode);
      Flits(data.parent).removeAttr('data-flits');
      Flits(parent).attr('data-flits', Flits.StoreCreditCart.settings.checkoutButtonParentParameterValue);
    }
  });
  // if(Flits.Metafields.IS_STORE_CREDIT_PAID && Flits.Metafields.is_store_credit_enable && window.flitsObjects.storeData.customer_id != -1){
  //       document.addEventListener('click', function(event) {
  //               var flits_credit_added_attr = Flits(event.target).attr("data-flits");
  //               console.log(flits_credit_added_attr)
  //                   if (typeof flits_credit_added_attr !== 'undefined' && flits_credit_added_attr == 'store-credit-added') {
  //                   var submitBtn = event.target;
  //                   return Flits.setupcheckoutProcess.apply(Flits.StoreCreditCart, [event, submitBtn]);          
  //                   }
  //       }, true);
  // }
}(Flits));
